import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "t2-block1 block_bj1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "trends" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "trends_info" }

import { ref } from 'vue';
import { useStore } from 'vuex';
import { getNewsContentList } from '@/config/request';
import { useRouter } from 'vue-router';
import { IMG_PREVIEW } from '@/config/const';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let newsTypeId = ref('') //  新闻类型id
let newsList = ref([]) as any   //  新闻列表

const store = useStore()
const router = useRouter()
const formateImg = (src:string) => {
    let imgSrc = '/images/dtimg.png'
    if(src){
        imgSrc = IMG_PREVIEW + src
    }
    return imgSrc
}
const init = async() => {
    const newsTypeList = await store.dispatch('getNewsType') as any
    newsTypeList.forEach((res:any)=>{
        if(res.themeName === '自贸区动态'){
            newsTypeId.value = res.id
            return false
        }
    })
    getNewsList()
}
const getNewsList = async() => {
    const param = {
        themeId: newsTypeId.value
    }
    const res = await getNewsContentList(param) as any
    if(res.result?.records.length > 6){
        newsList.value = res.result?.records.slice(0,6)
    }else{
        newsList.value = res.result?.records
    }
}
const showDetail = (item:any) => {
    console.log('item',item.id);

    router.push({
        path: '/news-detail',
        query:{
            id: item.id
        }
    })
}
const toNewsList = () => {
    let param = {
        themeId: newsTypeId.value,
        typeName: ''
    }
    router.push({
        path: '/news-list',
        query: param
    })
}
const oneStopService = () =>{
    router.push({
        path: '/oneStopService'
    })
}
init()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "linkblock" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("div", {
          class: "linkblock_icon1",
          onClick: oneStopService
        }, "外资企业开办一站式服务体系"),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "linkblock_icon2" }, "办不成事监督窗口", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", { class: "t2_title" }, [
        _createElementVNode("a", { onClick: toNewsList }, [...(_cache[1] || (_cache[1] = [
          _createTextVNode("查看更多", -1),
          _createElementVNode("i", { class: "leftAndright" }, null, -1)
        ]))]),
        _cache[2] || (_cache[2] = _createElementVNode("span", null, [
          _createTextVNode(" 自贸区动态"),
          _createElementVNode("br"),
          _createElementVNode("small", null, "FREE TRADE ZONE trends")
        ], -1))
      ]),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList), (item, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            onClick: ($event: any) => (showDetail(item))
          }, [
            _createElementVNode("img", {
              src: formateImg(item.bigIcon)
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("h1", null, "最新动态", -1)),
              _createElementVNode("small", null, _toDisplayString(item.releaseDate), 1),
              _createElementVNode("p", null, _toDisplayString(item.title), 1)
            ])
          ], 8, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}
}

})